import { render, staticRenderFns } from "./repair.vue?vue&type=template&id=ccc5488a&scoped=true&"
import script from "./repair.vue?vue&type=script&lang=js&"
export * from "./repair.vue?vue&type=script&lang=js&"
import style0 from "./repair.vue?vue&type=style&index=0&id=ccc5488a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc5488a",
  null
  
)

export default component.exports